<template>
<div class="chapter">
<div class="inner_page">
<div class="Basic-Text-Frame" id="_idContainer006">
<p class="CH-TITLE" id="_idParaDest-3"><span class="CharOverride-7"><a id="_idTextAnchor002"></a>I</span><span class="CharOverride-8">N</span><span class="CharOverride-7">T</span><span class="CharOverride-7">R</span><span class="CharOverride-9">O</span><span class="CharOverride-9">D</span><span class="CharOverride-7">U</span><span class="CharOverride-7">C</span><span class="CharOverride-7">T</span><span class="CharOverride-9">I</span><span class="CharOverride-7">O</span><span class="CharOverride-9">N</span></p>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-2">
</div>
</div>
<div class="Basic-Text-Frame" id="_idContainer007">
<p class="Normal ParaOverride-2 t"><span class="CharOverride-10">We always thought of the ’50s as Elvis and the postwar boom; the ’60s as Woodstock, free love, and getting high; and the ’70s as “The Me Decade,” living the good life amid fondue, lava lamps, and disco madness. Now that we’re </span><span class="CharOverride-11">in</span><span class="CharOverride-10"> our 50s, 60s, and 70s, those numbers mean something else entirely: our age. They also mean Social Security, little aches and pains, and the gateway to our third act. </span></p>
<p class="Normal ParaOverride-3"><span class="CharOverride-10">But really, things are just beginning to happen. We’re healthier, we live longer than the generations before us; we have later-in-life careers; we go on dating websites; we’re more engaged and travel farther.</span></p>
<p class="Normal ParaOverride-3"><span class="CharOverride-10">Older is getting younger every day.</span></p>
<p class="Normal ParaOverride-3"><span class="CharOverride-10">SO WHO’S COUNTING? is the book that proves it. It’s an acknowledgment and affirmation of our journey, chock-full of inspiration, humor, and reminders that things are just beginning to happen.</span></p>
<p class="Normal ParaOverride-4"><span class="CharOverride-10">The best is now.</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// SoWhosCounting_epub_final2.vue?3f57cb3b